import React from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Bar, BarChart, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import Skeleton from '@mui/material/Skeleton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { BlackPaper } from '../surface/Paper';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';

const UppercaseTypography = styled(Typography)({
  textTransform: 'uppercase',
});

const TooltipCard = styled(Card)({
  background: 'rgba(44, 44, 44, 0.8)',
  backdropFilter: 'blur(12px)',
  borderRadius: '4px',
  padding: '14px'
});

const ColorIndicator = styled('div')(({ color, opacity = 1 }) => ({
  width: 20,
  height: 20,
  border: '2px solid #FFFFFF',
  background: color,
  marginRight: '14px',
  opacity: opacity
}));

const FlexDiv = styled('div')({
  display: 'flex', 
  alignItems: 'center'
});

const MembershipPlansRepartition = () => {
	const { t } = useTranslation();
	
	// Use selector hooks instead of connect
	const stats = useSelector(state => state.stats.membershipStatsPlans);
	const loading = useSelector(state => state.stats.membershipStatsLoading);

	if (loading) {
		return (
      <Grid spacing={3} container>
        <Grid item xs={12}>
          <Skeleton height={300} style={{transform: 'scale(1,1)'}}/>
        </Grid>
      </Grid>
    );
	}

	const TooltipCustom = ({ payload, label, active, value }) => {
		if (active && payload) {
			return (
				<TooltipCard>
					<CardContent>
						<Typography variant="body1" color="textPrimary" align="center">
							{label}
						</Typography>
						<Typography variant="subtitle1" color="textPrimary" align="center">
						</Typography>
						{payload.map((item, index) => (
              <div key={index}>
                <FlexDiv>
                  <ColorIndicator color={item.fill} opacity={item.fillOpacity ?? 1} />
                  <div>
                    <Typography variant="h6" style={{color: item.fill}}>
                      {t(`dashboard_fanclub_stats_${item.name.toLowerCase()}_tooltip`)}
                    </Typography>
                    <Typography variant="h6" style={{color: item.fill}}>
                      {item.value}
                    </Typography>
                  </div>
                </FlexDiv>
              </div>
            ))}
					</CardContent>
				</TooltipCard>
			);
		}

		return null;
	};

	const CustomCursor = props => {
		const { x, y, width, height } = props;
		return <Rectangle fill="#2a2a2a" fillOpacity={0.75} x={x} y={y} width={width} height={height}/>;
	};

	return (
		<Card elevation={0} component={BlackPaper} style={{height: '100%', overflow: 'unset'}}>
			<CardContent>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<UppercaseTypography variant="h5" align="center">
							{t('plans_repartition')}
						</UppercaseTypography>
					</Grid>

					<Grid item xs={12}>
						<ResponsiveContainer width="99%" height={300}>
							<BarChart data={stats}>
								<XAxis dataKey="name"/>
								<YAxis/>
								<Tooltip content={<TooltipCustom/>} cursor={<CustomCursor/>} wrapperStyle={{zIndex: 1}}/>
								<Bar dataKey="Active" stackId="a" fill="#F2702E"/>
								<Bar dataKey="Inactive" stackId="a" fill="#F2702E" fillOpacity={0.5}/>
							</BarChart>
						</ResponsiveContainer>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};

export default MembershipPlansRepartition;